import React from "react";
import { preciousMomentVideo } from "../utils/constants";

function Video() {
  return (
    <div className="cake-video">
      <div className="video-content">
        <h3>Lorem ipsum dolor sit amet,</h3>
        <video autoPlay muted loop type="video/mp4">
          <source src={preciousMomentVideo} />
        </video>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos eaque dolorum dolores assumenda et, ad ipsa aliquid excepturi dignissimos. Dicta.</p>
      </div>
    </div>
  );
}

export default Video;
